import * as React from 'react';
import Button from '@mui/material/Button';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';

const DisableBeneficiary = ({ onClick }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
      <Button
        onClick={onClick}
        startIcon={<DeleteSweepIcon />}
        sx={{
          background: "rgba(224, 46, 26, 0.1)",
          width: "220px",
          height: "54px",
          padding: "15px 16px",
          borderRadius: "8px",
          fontFamily: 'Poppins, sans-serif',
          color: '#E02E1A',
          fontSize: '16px',
          fontWeight: 200,
          textTransform: 'none',
          '&:hover': {
            backgroundColor: "rgba(224, 46, 26, 0.1)",
          },
        }}
      >
        Excluir beneficiário
      </Button>
    </div>
  );
};

export default DisableBeneficiary;
